





import { Component, Vue, PropSync, Emit, Prop } from 'vue-property-decorator';
import { AnalysisProperties} from './types';
import { Farm } from '@/api/farms/types';
import AnalysisModal from '../analysisModal/AnalysisModal.vue';
import * as analysesService from "@/services/analyses";
import { analysisDTO } from '@/api/analyses/types';
import { AvailabilityDTO } from "@/api/products/types";
import { getProducts } from "@/api/products"

@Component({
  name: 'AnalysisModalController',
  components: {
    AnalysisModal,
  }
})
export default class AnalysisModalController extends Vue {

  @Prop({ type: Farm, required: false })
  private farmToAnalysis!: Farm | null;

  @Prop({ type: String, required: false })
  private analysisType!: string | null;

  @PropSync("modalState", { type: Boolean, default: false }) private modal !: boolean;

  private products: AvailabilityDTO[] = []

  private async created() {
    this.products = (await getProducts()).data
  }

  private closeCreateAnalysis() {
    this.$emit('oncancel');
  }

  @Emit("oncancel")
  private async createAnalysis(analysisProperties: AnalysisProperties) {
    
    const analysis = analysisDTO(
      analysisProperties.farm!.uuid,
      analysisProperties.summerCulture,
      analysisProperties.winterCulture,
      analysisProperties.farm!.geom,
      analysisProperties.period,
      analysisProperties.monitoring
    );

    await analysesService.createAnalysis(analysis, analysisProperties.analysisType);
    
  }
}
